<template>
  <div
    class="card-main"
    @click="clickCard"
    @mouseover="focusOn"
    @mouseleave="focusOut"
  >
    <div class="focus-ring" v-show="isfocusOn && mouseActivated"></div>
    <div class="card-text">
      {{ cardData.buttonName }}
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isActiveVue: true,
      isfocusOn: false,
    };
  },
  props: {
    cardData: Object,
  },

  computed: {
    mouseActivated() {
      return this.$store.getters.mouseActivated;
    },
  },

  methods: {
    clickCard() {
      switch (this.cardData.type) {
        case "account":
          this.$router.push({
            name: "account",
            params: {
              t: new Date().getTime(),
            },
          });
          break;
        case "terms":
          this.$router.push({
            name: "terms",
            params: {
              t: new Date().getTime(),
            },
          });
          break;
        case "logout":
          this.$router.push({
            name: "logout",
            params: {
              t: new Date().getTime(),
            },
          });
          break;
      }
      this.focusOut();
    },
    focusOn() {
      this.isfocusOn = true;
    },
    focusOut(){
      this.isfocusOn = false;
    }
  },
};
</script>

<style scoped>
.card-main {
  position: relative;
  display: inline-block;
  width: 320px;
  height: 320px;
  margin-right: 20px;
  background-color: #2c2c2c;
}
.card-text {
  display: inline-block;
  width: 320px;
  height: 28px;
  top: 146px;
  font-size: 28px;
  line-height: 1;
  text-align: center;
  color: #ededed;
}
.focus-ring {
  position: absolute;
  left: -5px;
  top: -4px;
  height: 320px;
  width: 320px;
  border: solid 4px #eeeeee;
  z-index: 5;
}

@media all and (min-width:0px) and (max-width:1280px){
  .card-main {
    position: relative;
    display: inline-block;
    width: 200px;
    height: 200px;
    margin-right: 16px;
    background-color: #2c2c2c;
  }

  .card-text {
    display: inline-block;
    width: 100%;
    height: 24px;
    top: 88px;
    font-size: 20px;
    line-height: 1;
    text-align: center;
    color: #ffffff;
  }
  .focus-ring {
    position: absolute;
    left: -5px;
    top: -4px;
    height: 208px;
    width: 208px;
    border: solid 4px #ffffff;
    z-index: 5;
  }
}
</style>